import moment from "moment";
import { useTranslation } from "react-i18next";
import { IoIosEye, IoIosEyeOff } from "react-icons/io";
import { accNoFormat, amountFormat } from "../services/common.service";
import { Button, Empty } from "antd";

export default function SalaryAdvanceGrid({ dataSource, accDetails }) {
  const { t } = useTranslation();
  
  return (
    <>
      <div className="table-body" style={{ minHeight: 300, padding: "0px" }}>
        <div className="row account-column-header">
          <div className="col-2">Loan ID</div>
          <div className="col-2">Amount</div>
          <div className="col-2">Date</div>
          <div className="col-2">Loan Status</div>
          <div className="col-2">Transaction Status</div>
          <div className="col-2">Reference Number</div>
        </div>
        {dataSource.map((option, idx) => (
          <div className="" style={{ marginBottom: 10 }}>
            <div
              className="row account-row-data"
              style={{ margin: 0, paddingLeft: 0 }}
            >
              <div className="col-2">{option.loanId || "-"}</div>
              <div className="col-2">
                {amountFormat(option.loanAmount, accDetails?.accountCurrency)}
              </div>
              <div className="col-2">
                {moment(option?.date).format("DD-MM-YYYY") || "-"}
              </div>
              <div className="col-2">{option.loanStatus || "-"}</div>
              <div className="col-2">{option.transactionStatus || "-"}</div>
              <div className="col-2">{option.cbsReferenceNumber || "-"}</div>
            </div>
          </div>
        ))}
        {dataSource.length === 0 && (
          <Empty
            description={t("common.no_records_found", {
              defaultValue: "No Records Found",
            })}
          />
        )}
      </div>
    </>
  );
}
